export let langObject = {
"Dashboard":{"tr":"Anasayfa"},
"Total Query":{"tr":"Toplam Sorgu"},
"Positive":{"tr":"Olumlu"},
"Negative":{"tr":"Olumsuz"},
"Neutral":{"tr":"Tarafsız"},
"Satisfaction":{"tr":"Memnuniyet"},
"Satisfaction in Channels":{"tr":"Kanallardaki Memnuniyet"},
"Channels":{"tr":"Kanallar"},
"Channel":{"tr":"Kanal"},
"Email":{"tr":"E-posta"},
"Password":{"tr":"Şifre"},
"Top 5 Channels":{"tr":"En Çok Kullanılan 5 Kanal"},
"Reports":{"tr":"Raporlar"},
"Channel Type":{"tr":"Kanal Tipi"},
"Add Channel":{"tr":"Kanal Ekle"},
"Update Channel":{"tr":"Kanal Güncelle"},
"Settings":{"tr":"Ayarlar"},
"Remember Me":{"tr":"Beni Hatırla"},
"Forgot Password ?":{"tr":"Şifreni mi unuttun?"},
"Login":{"tr":"Giriş Yap"},
"Please Wait...":{"tr":"Lütfen Bekleyin..."},
"Your Statistics":{"tr":"Sizin İstatistikleriniz"},
"Sentiment in the Last Year":{"tr":"Son 1 Yıldaki Duygular"},
"Sentiment in the Last Month":{"tr":"Son 1 Aydaki Duygular"},
"Last 7 days":{"tr":"Son 7 gün"},
"Last 30 days":{"tr":"Son 30 gün"},
"Today":{"tr":"Bugün"},
"Date":{"tr":"Tarih"},
"Users list":{"tr":"Kullanıcı listesi"},
"User Management":{"tr":"Kullanıcı Yönetimi"},
"Company":{"tr":"Şirket"},
"Profile":{"tr":"Profil"},
"Account Settings":{"tr":"Hesap Ayarları"},
"My Profile":{"tr":"Profilim"},
"Sign Out":{"tr":"Çıkış Yap"},
"Language":{"tr":"Dil"},
"Account":{"tr":"Hesap"},
"Filter Options":{"tr":"Filtre Seçenekleri"},
"Role":{"tr":"Rol"},
"All":{"tr":"Tümü"},
"Account Owner":{"tr":"Hesap Sahibi"},
"Analyst":{"tr":"Analist"},
"Developer":{"tr":"Geliştirici"},
"Last Login":{"tr":"Son Giriş"},
"20 minutes ago":{"tr":"20 dakika önce"},
"seconds ago":{"tr":"saniye önce"},
"days ago":{"tr":"gün önce"},
"hours ago":{"tr":"saat önce"},
"second ago":{"tr":"saniye önce"},
"day ago":{"tr":"gün önce"},
"hour ago":{"tr":"saat önce"},
"5 hours ago":{"tr":"5 saat önce"},
"Yesterday":{"tr":"Dün"},
"2 days ago":{"tr":"2 gün önce"},
"Reset":{"tr":"Sıfırla"},
"Apply":{"tr":"Uygula"},
"Filter":{"tr":"Filtre"},
"Add User":{"tr":"Kullanıcı Ekle"},
"Update User":{"tr":"Kullanıcı Güncelle"},
"Full Name":{"tr":"Ad Soyad"},
"This role has all the rights of the company":{"tr":"Bu rol şirketin tüm haklarına sahiptir."},
"Admin":{"tr":"Admin"},
"Best for business owners and company administrators":{"tr":"İşletme sahipleri ve şirket yöneticileri için en iyisi"},
"Best for developers or people primarily using the API":{"tr":"Geliştiriciler veya öncelikle API kullanan kişiler için en iyisi"},
"Best for people who need full access to analytics data, but don\'t need to update business settings":{"tr":"Analitik verilerine tam erişime ihtiyaç duyan ancak iş ayarlarını güncellemesi gerekmeyen kişiler için en iyisi"},
"Discard":{"tr":"At"},
"Submit":{"tr":"Gönder"},
"Avatar":{"tr":"Avatar"},
"Wrong email format":{"tr":"Yanlış e-posta formatı"},
"Minimum 3 symbols":{"tr":"En az 3 sembol"},
"Maximum 50 symbols":{"tr":"Maksimum 50 sembol"},
"Maximum 21 symbols":{"tr":"Maksimum 21 sembol"},
"Email is required":{"tr":"E-posta gereklidir"},
"Name is required":{"tr":"İsim gereklidir"},
"Name":{"tr":"İsim"},
"Online":{"tr":"Online"},
"Status":{"tr":"Durum"},
"Joined Day":{"tr":"Katılım Günü"},
"Processing...":{"tr":"Yükleniyor..."},
"There is an error occured during your request!":{"tr":"İsteğiniz sırasında bir hata oluştu!"},
"Please enter your full name!":{"tr":"Lütfen tam adınızı giriniz!"},
"The login details are incorrect":{"tr":"Giriş Bilgileriniz Yanlış"},
"There is an account already with this email!":{"tr":"Bu e-posta ile zaten bir hesap var!"},
"Actions":{"tr":"Islemler"},
"Successful":{"tr":"Başarılı"},
"Your old password is not correct!":{"tr":"Eski şifreniz doğru değil!"},
"Your new password is the same with old one! Please enter a different password.":{"tr":"Yeni şifreniz eskisi ile aynı! Lütfen farklı bir şifre girin."},
"The new password cannot be the same as the current password.":{"tr":"Yeni şifre mevcut şifre ile aynı olamaz."},
"Password contains unwanted characters!":{"tr":"Şifre istenmeyen karakterler içeriyor!"},
"Password doesn't match the confirmation!":{"tr":"Parola onayla eşleşmiyor!"},
"Password is too short (minimum is 8 characters)!":{"tr":"Şifre çok kısa (minimum 8 karakter)!"},
"Edit":{"tr":"Düzenle"},
"Delete":{"tr":"Sil"},
"Search user":{"tr":"Kullanıcı ara"},
"Light":{"tr":"Aydınlık"},
"Dark":{"tr":"Karanlık"},
"System":{"tr":"Sistem"},
"No matching records found":{"tr":"Hiçbir eşleşen kayıt bulunamadı"},
"Selected":{"tr":"Seçildi"},
"Delete Selected":{"tr":"Seçilenleri Sil"},
"Activate":{"tr":"Aktifleştir"},
"Deactivate":{"tr":"Pasifleştir"},
"Active":{"tr":"Aktif"},
"Sent password reset. Please check your email":{"tr":"Parola sıfırlama gönderildi. Lütfen emailinizi kontrol edin"},
"Passive":{"tr":"Pasif"},
"Overall Sentiment Distribution":{"tr":"Genel Duygu Dağılımı"},
"Your Sentiment Distribution":{"tr":"Sizin Duygu Dağılımınız"},
"Password is required":{"tr":"Şifre gereklidir"},
"Passwords must match":{"tr":"Şifreler eşleşmelidir"},
"Current Password":{"tr":"Mevcut Şifre"},
"New Password":{"tr":"Yeni Şifre"},
"Confirm New Password":{"tr":"Yeni Şifre Doğrulama"},
"Password must be at least 8 character and contain symbols":{"tr":"Şifre en az 8 karakter olmalı ve semboller içermelidir"},
"Cancel":{"tr":"İptal"},
"Reset Password":{"tr":"Şifreyi Yenile"},
"Full name is required":{"tr":"Ad soyad gereklidir"},
"Company name is required":{"tr":"Şirket adı gereklidir"},
"Contact phone is required":{"tr":"İrtibat telefonu gereklidir"},
"Company website is required":{"tr":"Şirket web sitesi gereklidir"},
"Country is required":{"tr":"Ülke gereklidir"},
"Language is required":{"tr":"Dil gereklidir"},
"Time zone is required":{"tr":"Saat dilimi gereklidir"},
"Currency is required":{"tr":"Para birimi gereklidir"},
"Profile Details":{"tr":"Profil Detayları"},
"Company name":{"tr":"Şirket adı"},
"Full name":{"tr":"Ad soyad"},
"Phone number":{"tr":"Telefon numarası"},
"Company Website":{"tr":"Şirket Web Sitesi"},
"Company website":{"tr":"Şirket web sitesi"},
"Contact Phone":{"tr":"İrtibat Telefonu"},
"Country":{"tr":"Ülke"},
"Select a country...":{"tr":"Bir ülke seçin..."},
"Select a language...":{"tr":"Bir dil seçin..."},
"Please select a preferred language, including date, time, and number formatting.":{"tr":"Lütfen tarih, saat ve sayı biçimlendirmesi dahil olmak üzere tercih ettiğiniz dili seçin."},
"Time Zone":{"tr":"Zaman Dilimi"},
"Please wait...":{"tr":"Lütfen bekleyin..."},
"Select a timezone...":{"tr":"Bir zaman dilimi seçin..."},
"Membership Type":{"tr":"Üyelik Türü"},
"Select a membership type...":{"tr":"Bir üyelik türü seçin..."},
"Free":{"tr":"Ücretsiz"},
"Save":{"tr":"Kaydet"},
"Email Preferences":{"tr":"E-posta Tercihleri"},
"Insights":{"tr":"Raporlar"},
"Receive highlight subjects, customer satisfaction and competitor analysis reports.":{"tr":"Öne çıkan konuları, müşteri memnuniyetini ve rakip analiz raporlarını alın."},
"New Invoices":{"tr":"Yeni Faturalar"},
"Receive information for our new invoices.":{"tr":"Yeni faturlarımız için bilgilendirme alın."},
"Receive information for our new newsletters.":{"tr":"Yeni bültenlerimiz için bilgilendirme alın."},
"Blogs":{"tr":"Blog Yazılarımız"},
"Receive information for our new blogs.":{"tr":"Yeni blog yazılarımız için bilgilendirme alın."},
"Campaigns":{"tr":"Kampanyalar"},
"Receive information for our new campaigns.":{"tr":"Yeni kampanyalarımız için bilgilendirme alın."},
"Usage Alerts":{"tr":"Kullanım Uyarıları"},
"Receive information for usage alerts.":{"tr":"Kullanım uyarıları için bilgilendirme alın."},
"Notifications":{"tr":"Bildirimler"},
"Phone":{"tr":"Telefon"},
"Billing Updates":{"tr":"Fatura Güncellemeleri"},
"Successful Payments":{"tr":"Başarılı Ödemeler"},
"Newsletters":{"tr":"Bültenler"},
"Account has been successfully deleted!":{"tr":"Hesap başarıyla silindi!"},
"Freeze Account":{"tr":"Hesabı Dondur"},
"You Are Deactivating Your Account":{"tr":"Hesabınızı Donduruyorsunuz"},
"For extra security, this process requires you to enter your password.":{"tr":"Ekstra güvenlik için, bu işlem parolanızı girmenizi gerektirir."},
"I confirm my account deactivation":{"tr":"Hesabımın dondurulmasını onaylıyorum"},
"Upgrade your account":{"tr":"Hesabınızı yükseltin"},
"Profile Compleation":{"tr":"Profil Tamamlama"},
"Default Avatar":{"tr":"Varsayılan Avatar"},
"Company Details":{"tr":"Şirket Detayları"},
"Company Name":{"tr":"Şirket Adı"},
"Default Language":{"tr":"Varsayılan Dil"},
"Default Time Zone":{"tr":"Varsayılan Zaman Dilimi"},
"Company account successfully frozen!":{"tr":"Şirket hesabı başarıyla donduruldu!"},
"Freeze Company Account":{"tr":"Şirket Hesabını Dondur"},
"You Are Deactivating Your Company Account":{"tr":"Şirket Hesabınızı Donduruyorsunuz"},
"I confirm my company account deactivation":{"tr":"Şirket hesabımın dondurulmasını onaylıyorum"},
"Starter":{"tr":"Başlangıç"},
"Best for startups":{"tr":"Startup'lar için en iyisi"},
"Optimal for mimimum usage and new startup":{"tr":"Minimum kullanım ve yeni başlatma için ideal"},
"Up to 5 Team Members":{"tr":"En Fazla 5 Takım Arkadaşı"},
"Up to 5 Data Source Integrations":{"tr":"En Fazla 5 Veri Kaynağı Entegrasyonu"},
"Analysis Panel":{"tr":"Analiz Paneli"},
"AI Improvement Screens":{"tr":"YZ Geliştirme Ekraları"},
"Feature Enhancement Request":{"tr":"Özellik Geliştirme Talebi"},
"Download Reports":{"tr":"Raporları İndirme"},
"Notification by EMail":{"tr":"E-posta ile Bildirim"},
"Professional":{"tr":"Profesyonel"},
"Optimal for normal usage and midsize company":{"tr":"Normal kullanım ve orta ölçekli şirket için ideal"},
"Up to 10 Team Members":{"tr":"En Fazla 10 Takım Arkadaşı"},
"Up to 10 Data Source Integrations":{"tr":"En Fazla 10 Veri Kaynağı Entegrasyonu"},
"Edit Data Channels":{"tr":"Veri Kanallarını Düzenle"},
"Enterprise":{"tr":"Kurumsal"},
"Flexible":{"tr":"Esnek"},
"Api":{"tr":"Api"},
"No Data Source Integrations":{"tr":"Veri Kaynağı Entegrasyonu Yok"},
"Optimal for best usage and software developers":{"tr":"En iyi kullanım ve yazılım geliştiriciler için ideal"},
"View membership types":{"tr":"Üyelik türlerini görüntüleyin"},
"Update Company Information":{"en":"Şirket Bilgilerini Güncelle"},
"Best for largesize companies":{"tr":"Büyük ölçekli şirketler için en iyisi"},
"Optimal for best usage and largesize company":{"tr":"En iyi kullanım ve büyük ölçekli şirket için ideal"},
"Most popular":{"tr":"En popüler"},
"Up to 20 Team Members":{"tr":"En Fazla 20 Takım Arkadaşı"},
"Up to 20 Data Source Integrations":{"tr":"En Fazla 20 Veri Kaynağı Entegrasyonu"},
"Custom":{"tr":"Özel"},
"Source":{"tr":"Kanal"},
"Request a custom license":{"tr":"Özel bir lisans iste"},
"Upgrade Plan":{"tr":"Planı Yükselt"},
"If you need more info, please write to us:":{"tr":"Daha fazla bilgiye ihtiyacınız varsa lütfen bize yazın:"},
"Send Email":{"tr":"E-posta gönder"},
"Monthly":{"tr":"Aylık"},
"Annual":{"tr":"Yıllık"},
"Year":{"tr":"Yıl"},
"Contact Us":{"tr":"Bize Ulaşın"},
"Month":{"tr":"Ay"},
"5,000 texts per month.":{"tr":"Ayda 5.000 metin."},
"12,000 texts per month.":{"tr":"Ayda 12.000 metin."},
"15,000 texts per month. After each 100 texts 2,66 $.":{"tr":"Ayda 15.000 metin. Sonrası her 100 metin 74,49 ₺."},
"25,000 texts per month. After each 1,000 texts 9,49 $.":{"tr":"Ayda 25.000 metin. Sonrası her 1.000 metin 265 ₺."},
"5% discount on annual plan.":{"tr":"Yıllık planda %5 indirim."},
"10% discount on annual plan.":{"tr":"Yıllık planda %10 indirim."},
"$":{"tr":"₺"},
"Text":{"tr":"Metin"},
"Sentiment":{"tr":"Duygu"},
"Create Date":{"tr":"Oluşturma Tarihi"},
"Sentiment Distribution in Channels":{"tr":"Kanallardaki Duygu Dağılımı"},
"Sign Up":{"tr":"Kayıt Ol"},
"Name Surname":{"tr":"Ad Soyad"},
"Use 8 or more characters with a mix of letters, numbers & symbols.":{"tr":"Harf, sayı ve sembol karışımıyla 8 veya daha fazla karakter kullanın."},
"Confirm Password":{"tr":"Şifre (Tekrar)"},
"Not a Member yet?":{"tr":"Daha üye değil misin?"},
"Sign up":{"tr":"Üye Ol"},
"Are you a Member?":{"tr":"Üye misin?"},
"Name Surname is required":{"tr":"Ad Soyad zorunludur"},
"Maximum 100 symbols":{"tr":"Maksimum 100 sembol"},
"Maximum 100 symbols":{"tr":"Maksimum 100 sembol"},
"Password confirmation is required":{"tr":"Şifre onayı gerekli"},
"I accept the terms.":{"tr":"Koşulları kabul ediyorum."},
"The passwords you entered do not match.":{"tr":"Girdiğiniz şifreler birbiriyle uyuşmuyor."},
"You must accept the terms and conditions":{"tr":"Şartları ve koşulları kabul etmelisiniz"},
"Your password should be 8-15 characters long and should contain at least one lowercase, one uppercase, one numeric digit and one special characters!":{"tr":"Şifreniz 8-15 karakter uzunluğunda olmalı ve en az bir küçük harf, bir büyük harf, bir sayısal rakam ve bir özel karakter içermelidir!"},
"Sent activate account email. Please check your email.":{"tr":"Hesap etkinleştirme e-postası gönderildi. Lütfen e-postanızı kontrol edin."},
"Your password has been changed successfully. Please log in to continue.":{"tr":"Parolanız başarıyla değiştirildi. Devam etmek için lütfen giriş yapınız."},
"Sorry, looks like there are some errors detected, please try again.":{"tr":"Maalesef bazı hatalar algılandı, lütfen tekrar deneyin."},
"Add Review":{"tr":"İnceleme Ekle"},
"Update Review":{"tr":"İnceleme Güncelle"},
"Search review":{"tr":"İnceleme ara"},
"Review added successfully!":{"tr":"İnceleme başarıyla eklendi!"},
"Review updated successfully!":{"tr":"İnceleme başarıyla güncellendi!"},
"Review deleted successfully!":{"tr":"İnceleme başarıyla silindi!"},
"Please check the box to deactivate your account":{"tr":"Hesabınızı devre dışı bırakmak için lütfen kutuyu işaretleyin"},
"Artificial Intelligence":{"tr":"Yapay zeka"},
"Sentiment Analysis":{"tr":"Duygu Analizi"},
"Id":{"tr":"Id"},
"Text is required":{"tr":"Metin gerekli"},
"Update Password":{"tr":"Şifre güncelle"},
"Enter your email to reset your password.":{"tr":"Parolanızı sıfırlamak için e-postanızı girin."},
"Twitter":{"tr":"Twitter"},
"All Platforms":{"tr":"Tüm Platformlar"},
"Platform":{"tr":"Platform"},
"Tokens":{"tr":"Tokenlar"},
"Search token":{"tr":"Token ara"},
"Add Token":{"tr":"Token Ekle"},
"Update Token":{"tr":"Token Güncelle"},
"Token Text":{"tr":"Token Metni"},
"Plain Token Texts":{"tr":"Saf Token Metinleri"},
"Channel Name":{"tr":"Kanal Adı"},
"Channel Name is required":{"tr":"Kanal Adı gerekli"},
"Search query is required":{"tr":"Arama sorgusu gerekli"},
"Api":{"tr":"Api"},
"Total":{"tr":"Toplam"},
"Şikayet Var":{"tr":"Şikayet Var"},
"in 20 minutes":{"tr":"20 dakika içinde"},
"in 5 hours":{"tr":"5 saat içinde"},
"in today":{"tr":"Bugün içinde"},
"in 7 days":{"tr":"7 gün içinde"},
"in 1 month":{"tr":"1 ay içinde"},
"in 1 year":{"tr":"1 yıl içinde"},
"Last 1 year":{"tr":"Son 1 yıl"},
"Token Sentiment Distribution":{"tr":"Token Duygu Dağılımı"},
"Subject Sentiment Distribution":{"tr":"Konu Duygu Dağılımı"},
"Total Token":{"tr":"Toplam Token"},
"Grand Total":{"tr":"Genel Toplam"},
"Select a sentiment...":{"tr":"Bir duygu seçin..."},
"Sentiment is required":{"tr":"Duygu gerekli"},
"Child Sentence":{"tr":"Alt Cümle"},
"Translated Child Sentence":{"tr":"Çevirilmiş Alt Cümle"},
"Child Sentence Sentiment":{"tr":"Alt Cümle Duygusu"},
"Child Sentence Subject":{"tr":"Alt Cümle Konusu"},
"Contact Us":{"tr":"Bize Ulaşın"},
"About Us":{"tr":"Hakkımızda"},
"Copyright":{"tr":"Telif hakkı"},
"Token":{"tr":"Token"},
"We offer artificial intelligence software solutions.":{"tr":"Yapay zekalı yazılım çözümleri sunuyoruz."},
"We strive for creative product development, high-performance service and continuous improvement.":{"tr":"Yaratıcı ürün geliştirme, yüksek başarılı servis sağlama ve sürekli daha iyisine ulaşma çabasındayız."},
"An unexpected error has occurred":{"tr":"Beklenmeyen bir hata oluştu"},
"Don't forget to add channels to reach people's opinions.":{"tr":"İnsanların görüşlerine ulaşabilmek için kanallar eklemeyi unutmayın."},
"The channel has been successfully added.":{"tr":"Kanal başarıyla eklendi."},
"The channel has been successfully updated.":{"tr":"Kanal başarıyla güncellendi."},
"Channel type is required":{"tr":"Kanal türü gerekli"},
"Channel name is required":{"tr":"Kanal ismi gerekli"},
"Channel Search":{"tr":"Kanal Arama"},
"Text to Search":{"tr":"Aranacak Metin"},
"Texts to Search":{"tr":"Aranacak Metinler"},
"I want daily data collection.":{"tr":"Günlük veri toplama istiyorum."},
"Url to search":{"tr":"Aranacak url"},
"Search url is required":{"tr":"Arama url'i gereklidir"},
"The text you enter must be the url":{"tr":"Girdiğiniz metin url olmalıdır"},
"It looks like no channels have been added yet.":{"tr":"Henüz hiçbir kanal eklenmemiş gibi görünüyor."},
"The channel has been successfully deleted.":{"tr":"Kanal başarıyla silindi."},
"Test":{"tr":"Test"},
"Your activation info is wrong. Please contact AISenseUs support team!":{"tr":"Aktivasyon bilgileriniz yanlış. Lütfen AISenseUs destek ekibiyle iletişime geçin!"},
"Become a Team Member":{"tr":"Takım Üyesi Ol"},
"Your process has been started!":{"tr":"İşleminiz başlatılmıştır!"},
"Previous": {"tr":"Önceki"},
"Next": {"tr":"Sonraki"},
"Unexpected error": {"tr":"Beklenmeyen hata"},
"Team member added successfully!": {"tr":"Ekip üyesi başarıyla eklendi!"},
"Team member updated successfully!":{"tr":"Ekip üyesi başarıyla güncellendi!"},
"Token you entered is already exist.": {"tr":"Girdiğiniz token zaten mevcut."},
"Subject you entered is already exist.": {"tr":"Girdiğiniz konu zaten mevcut."},
"Leave a space for surname":{"tr":"Soyad için boşluk bırakın"},
"Enter a valid name surname":{"tr":"Geçerli bir ad soyad giriniz"},
"Please enter valid e-mail format":{"tr":"Geçerli e-posta formatı giriniz"},
"Email you entered is already belong to a team member in AISenseUs.":{"tr":"Girdiğiniz e-posta zaten AISenseUs'da bir ekip üyesine ait."},
"Membership type updated successfully!":{"tr":"Üyelik türü başarıyla güncellendi!"},
"Accounts of the \"Free\" type cannot add team members.":{"tr":"\"Ücretsiz\" türündeki hesaplar ekip üyesi ekleyemez."},
"Accounts of the \"Starter\" type can add a maximum of 5 team members.":{"tr":"\"Başlangıç\" türündeki hesaplar en fazla 5 ekip üyesi ekleyebilir."},
"Accounts of the \"Professional\" type can add a maximum of 10 team members.":{"tr":"\"Profesyonel\" türündeki hesaplar en fazla 10 ekip üyesi ekleyebilir."},
"Company infos updated successfully!":{"tr":"Şirket bilgileri başarıyla güncellendi!"},
"Token text and plain texts can't be empty.":{"tr":"Token metni ve saf token metni boş bırakılamaz."},
"If you want, try writing to us here before you decide.":{"tr":"İsterseniz, karar vermeden önce bize buradan yazmayı deneyin."},
"Your account has been freezed successfully.":{"tr":"Hesabınız başarıyla donduruldu."},
"Your company account has been freezed successfully.":{"tr":"Şirket hesabınız başarıyla donduruldu."},
"Token you entered is not exist.":{"tr":"Girdiğiniz token mevcut değil."},
"The token has been successfully created.":{"tr":"Token başarıyla oluşturuldu."},
"The token has been successfully deleted.":{"tr":"Token başarıyla silindi."},
"The token has been successfully updated.":{"tr":"Token başarıyla güncellendi."},
"Token text and plain texts can't be empty.":{"tr":"Token metni ve düz metinler boş olamaz."},
"Allowed file types: png, jpg, jpeg.":{"tr":"İzin verilen dosya türleri: png, jpg, jpeg."},
"Membership type is required":{"tr":"Üyelik türü gerekli"},
"Subject":{"tr":"Konu"},
"You can add a new value!":{"tr":"Yeni bir değer ekleyebilirsiniz!"},
"Select one/several subject(s)...":{"tr":"Bir/birkaç konu(lar) seçin..."},
"Select one subject...":{"tr":"Bir konu seçin..."},
"Create new...":{"tr":"Oluşturun..."},
"Subjects":{"tr":"Konular"},
"Total Count":{"tr":"Toplam"},
"All Subjects":{"tr":"Tüm Konular"},
"All Channels":{"tr":"Tüm Kanallar"},
"Search subject":{"tr":"Konu ara"},
"Add Subject":{"tr":"Konu Ekle"},
"Update Subject":{"tr":"Konu Güncelle"},
"Subject updated successfully!":{"tr":"Konu başarıyla güncellendi!"},
"Subject deleted successfully!":{"tr":"Konu başarıyla silindi!"},
"Subject added successfully!":{"tr":"Konu başarıyla eklendi!"},
"Are you sure to delete channel?":{"tr":"Kanalı silmek istediğinizden emin misiniz?"},
"Delete Channel":{"tr":"Kanalı Sil"},
"Click here to access the API.":{"tr":"Apiye erişmek için buraya tıklayınız."},
"The texts to be searched must be at least one, and the number of letters of the texts must be at least 3.":{"tr":"Aranacak metinler en az bir tane olmalı, metinlerin harf sayısı ise en az 3 olmalıdır."},
"Write one/several text(s)...":{"tr":"Bir/birkaç metin(ler) yazın..."},
"Write one/several username(s)...":{"tr":"Bir/birkaç kullanıcı adı(adları) yazın..."},
"Deleting this channel will cause the reports of the channel to be deleted as well.":{"tr":"Bu kanalın silinmesi, kanala ait raporların da silinmesine neden olacaktır."},
"Click on the link to access the commands of the API, try it on the site or download it as a collection for postman.":{"tr":"Api'nin komutlarına ulaşmak, site üzerinden denemek veya postman için koleksiyon olarak indirmek için bağlantıya tıklayınız."},
"Information Preferences":{"tr":"Bilgilendirme Tercihleri"},
"Notification":{"tr":"Bildirim"},
"Information preferences updated successfully!":{"tr":"Bilgilendirme tercihleri ​​başarıyla güncellendi!"},
"Translated Text":{"tr":"Çevrilmiş Metin"},
"Your download process has been started!":{"tr":"İndirme işleminiz başlatıldı!"},
"File downloaded successfully!":{"tr":"Dosya başarıyla indirildi!"},
"Everything is fine.":{"tr":"Herşey yolunda."},
"Alerts":{"tr":"Uyarılar"},
"Updates":{"tr":"Güncellemeler"},
"Logs":{"tr":"Loglar"},
"View All":{"tr":"Tümünü Görüntüle"},
"Upgrade":{"tr":"Yükselt"},
"To access this section, we will ask you to upgrade your product plan.":{"tr":"Bu bölüme erişmek için sizden ürün planınızı yükseltmenizi isteyeceğiz."},
"notification":{"tr":"bildirim"},
"Select an Image":{"tr":"Bir Resim Seçin"},
"Screeen Ratio":{"tr":"Ekran Oranı"},
"Dynamic":{"tr":"Dinamik"},
"Rotate":{"tr":"Döndürme"},
"Zoom":{"tr":"Yakınlaştırma"},
"Your profile updated successfully!":{"tr":"Profiliniz başarıyla güncellendi!"},
"Update profile image":{"tr":"Profil resmini güncelle"},
"Update company image":{"tr":"Şirket resmini güncelle"},
"Delete Review":{"tr":"İncelemeyi Sil"},
"You Are Deleting This Review":{"tr":"Bu İncelemeyi Siliyorsunuz"},
"You cannot undo this action. If you still want to delete it, you can delete the review from the button below.":{"tr":"Bu işlemi geri alamazsınız. Yine de silmek isterseniz aşağıdaki butondan incelemeyi silebilirsiniz."},
"Team member deleted successfully!":{"tr":"Ekip üyesi başarıyla silindi!"},
"Delete Token":{"tr":"Tokeni Sil"},
"You Are Deleting This Token":{"tr":"Bu Tokeni Siliyorsunuz"},
"Delete Subject":{"tr":"Konuyu Sil"},
"You Are Deleting This Subject":{"tr":"Bu Konuyu Siliyorsunuz"},
"Delete Team member":{"tr":"Ekip Üyesi Sil"},
"You Are Deleting a Team member":{"tr":"Bir Ekip Üyesi Siliyorsunuz"},
"Expiration time is required":{"tr":"Geçerlilik süresi gereklidir"},
"New Expiration Time":{"tr":"Yeni Geçerlilik Süresi"},
"Expiration Date":{"tr":"Geçerlilik Tarihi"},
"Ekşi Sözlük":{"tr":"Ekşi Sözlük"},
"IFrame":{"tr":"IFrame"},
"1 month":{"tr":"1 ay"},
"3 month":{"tr":"3 ay"},
"6 month":{"tr":"6 ay"},
"1 year":{"tr":"1 yıl"},
"2 year":{"tr":"2 yıl"},
"3 year":{"tr":"3 yıl"},
"Select a time to update the expiration date":{"tr":"Geçerlilik tarihini güncellemek için bir süre seçin"},
"Codes":{"tr":"Kodlar"},
"To run the IFrame, simply add the following codes to your web page.":{"tr":"IFrame'i çalıştırmak için web sayfanıza aşağıdaki kodları eklemeniz yeterlidir."},
"Your monthly reports have been sent to your email":{"tr":"Aylık raporlarınız e-postanıza gönderildi"},
"Instagram":{"tr":"Instagram"},
"Hashtag to Search":{"tr":"Aranacak Hashtagler"},
"Write one/several hashtag(s)...":{"tr":"Bir/birkaç hashtag(ler) yazın..."},
"Iframe":{"tr":"Iframe"},
"The hashtags to be searched must be at least one, and the number of letters of the hashtags must be at least 3. Hashtags must be start with '#' character":{"tr":"Aranacak hashtagler en az bir tane olmalı, hashtag'lerin harf sayısı ise en az 3 olmalıdır. Hashtag'ler '#' karakteriyle başlamalıdır."},
"starts with #":{"tr":"'#' ile başlamalı"},
"Youtube":{"tr":"Youtube"},
"Youtube Channel Id":{"tr":"Youtube Kanal Id"},
"Channel Id is required":{"tr":"Kanal Id gereklidir."},
"Minimum 5 symbols":{"tr":"Minimum 5 sembol"},
"Must be exactly 24 digits":{"tr":"24 Haneli olmalıdır"},
"This is a competitor channel.":{"tr":"Bu bir rakip kanaldır."},
"Competitor Name":{"tr":"Rakip Adı"},
"Competitor name is required":{"tr":"Rakip adı gereklidir"},
"All Competitors":{"tr":"Tüm Rakipler"},
"We":{"tr":"Biz"},
"Happiness Score Compared to Competitors":{"tr":"Rakiplere Göre Mutluluk Skoru"},
"Sentiment Analysis Compared to Competitors":{"tr":"Rakiplere Göre Duygu Analizi"},
"Sentiment and Subject Analysis Compared to Competitors":{"tr":"Rakiplere Göre Duygu ve Konu Analizi"},
"Platform Statistics":{"tr":"Platform İstatistikleri"},
"Happiness Score Compared to Platforms":{"tr":"Platformlara Göre Mutluluk Skoru"},
"Sentiment Analysis Compared to Platforms":{"tr":"Platformlara Göre Duygu Analizi"},
"Competition Statistics":{"tr":"Rekabet İstatistikleri"},
"You can add subjects from the 'Artificial Intelligence/Subjects page.":{"tr":"'Yapay Zeka/Konular' sayfasından konu ekleyebilirsiniz."},
"You can add competitors and turn on daily data collection from the 'Settings/Channels' page.":{"tr":"'Ayarlar/Kanallar' sayfasından rakip ekleyebilir ve günlük veri toplamayı açabilirsiniz."},
"You can add platforms and turn on daily data collection from the 'Settings/Channels' page.":{"tr":"'Ayarlar/Kanallar' sayfasından platform ekleyebilir ve günlük veri toplamayı açabilirsiniz."},
"Subreddit name is required":{"tr":"Subreddit adı gereklidir"},
"Subreddit name is wrong":{"tr":"Subreddit adı hatalı"},
"Subreddit Name":{"tr":"Subreddit Adı"},
"Queries to search":{"tr":"Aranacak sorgular"},
"Training Status":{"tr":"Eğitim Durumu"},
"Trained":{"tr":"Eğitildi"},
"Uncertain":{"tr":"Belirsiz"},
"Add Translation":{"tr":"Çeviri Ekle"},
"Translation added successfully!":{"tr":"Çeviri başarıyla eklendi!"},
"The language of the text is the same as yours!":{"tr":"Metnin dili sizin dilinizle aynı!"},
"Add Multiple Subject With AI":{"tr":"YZ ile Çoklu Konu Ekle"},
"Business Defination":{"tr":"İş Tanımı"},
"Business defination is required":{"tr":"İş tanımı gereklidir"},
"Get AI Suggestions":{"tr":"Yapay Zeka Önerileri Al"},
"Subject suggestions received successfully!":{"tr":"Konu önerileri başarıyla alındı!"},
"Maximum 250 symbols":{"tr":"Maksimum 250 sembol"},
"Maximum 50 symbols":{"tr":"Maksimum 50 sembol"},
"Minimum 50 symbols":{"tr":"Minimum 50 sembol"},
"Change View":{"tr":"Görünümü Değiştir"},
"Facebook":{"tr":"Facebook"},
"Reddit":{"tr":"Reddit"},
"Datas":{"tr":"Veriler"},
"Deleted":{"tr":"Silinmiş"},
"Prepared Subject Sentiment Distribution":{"tr":"Hazır Konu Duygu Dağılımı"},
"Auto Class":{"tr":"Hazır Konu"},
"Instagram Comments":{"tr":"Instagram Yorumları"},
"Instagram Mentions":{"tr":"Instagram Bahsetmeleri"},
"Instagram Username":{"tr":"Instagram Kullanıcı Adı"},
"Instagram username is required":{"tr":"Instagram kullanıcı adı gereklidir"},
"Instagram username is wrong":{"tr":"Instagram kullanıcı adı hatalıdır"},
"Blocked Instagram Usernames":{"tr":"Engellenen Instagram Kullanıcı Adları"},
"Blocked Twitter Usernames":{"tr":"Engellenen Twitter Kullanıcı Adları"},
"You must add at least one username to block the search. You must enter your own username. Usernames must be at least 3 letters and contain only lowercase letters, numbers and _":{"tr":"Aramayı engellemek için en az bir kullanıcı adı eklemelisiniz. Kendi kullanıcı adınızı girmelisiniz. Kullanıcı adları en az 3 harften oluşmalı ve yalnızca küçük harf, rakam ve _ içermelidir"},
"Your username can only contain lowercase letters, uppercase letters, numbers, \".\" and \"_\"":{"tr":"Kullanıcı adınız yalnızca küçük harfler, büyük harfler, sayılar, \".\" ve \"_\" içerebilir"},
"TikTok Mentions":{"tr":"TikTok Bahsetmeleri"},
"TikTok Comments":{"tr":"TikTok Yorumları"},
"TikTok Username":{"tr":"TikTok Kullanıcı Adı"},
"Blocked TikTok Usernames":{"tr":"Engellenen TikTok Kullanıcı Adları"},
"TikTok username is required":{"tr":"TikTok kullanıcı adı gereklidir"},
"Auto Group With AI":{"tr":"YZ ile Otomatik Gruplandır"},
"Only those without groups":{"tr":"Sadece gurupsuz olanlar"},
"subjects updated.":{"tr":"konu eklendi."},
"Group":{"tr":"Gurup"},
"Competition Volume Distribution":{"tr":"Rekabet Hacim Dağılımı"},
"Happiness Score":{"tr":"Mutluluk Skoru"},
"Competition Happiness Scores":{"tr":"Rekabet Mutluluk Skorları"},
"Volume":{"tr":"Hacim"},
"EkşiSözlük":{"tr":"EkşiSözlük"},
"ŞikayetVar":{"tr":"ŞikayetVar"},
"Competitor":{"tr":"Rakip"},
"To upgrade your subscription plan, please send an e-mail to buy@aisenseus.net":{"tr":"Abonelik planınızı yükseltmek için lütfen buy@aisenseus.net adresine e-posta gönderin."},
"":{"tr":""},
"":{"tr":""},
};

